import sdk, { type SalonStockerHttpTypes, withMeta } from "@repo/api-sdk";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { queryKeys } from "./queryKeys";

export interface ProductsPricingQueryParams {
  product_ids: string[];
}

export function productsPricingQuery(params: ProductsPricingQueryParams) {
  return queryOptions({
    queryKey: queryKeys.productsPricing(params.product_ids),
    queryFn: () => sdk.store.product.resolvePricing(params.product_ids),
    enabled: params.product_ids.length > 0
  });
}

/**
 * Hook to fetch pricing information for multiple products.
 *
 * @param params - Query parameters
 * @param params.product_ids - Array of product IDs to fetch pricing for (max 20)
 * @returns Query result containing products with pricing data and metadata
 *
 * @remarks
 * The query is only enabled when there are between 1 and 20 product IDs. (API limit)
 * Results are automatically enriched with metadata using the `withMeta` transformer.
 */
export function useProductsPricing(params: ProductsPricingQueryParams) {
  return useQuery({
    ...productsPricingQuery(params),
    select: (
      data: SalonStockerHttpTypes.StoreProductPricingResponse
    ): SalonStockerHttpTypes.StoreProductPricingResponse<"meta"> => ({
      products: data.products.map(withMeta)
    })
  });
}
